import React from 'react';
import { Link } from "react-router-dom";

const Button = (props) => {
    const styles = {
      backgroundColor: "hsl(0, 0%, 22%)",
      color: "gold",
      padding: "10px 20px",
      borderRadius: "5px",
      border: "none",
      cursor: "pointer",
      width: "130px",
      fontSize: "1.05rem",
      height: "60px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }

    return (
      <Link to={props.to} style={{ textDecoration: 'none' }}>
        <button style={styles}>
          {props.message}
        </button>
      </Link>
    );
  }

export default Button;